<template>
    <div class="mb-3">
        <h3>Aircraft Information</h3>

        <div class="form-floating mb-3">

            <select v-model="store.dataSetId" class="form-select" id="floatingCountry" :class="{ 'is-invalid': v$.dataSetId.$errors.length > 0 }">
                <option v-for="dataSet in store.dataSets" :value="dataSet.id">{{ dataSet.country }} - {{ dataSet.countryName }}</option>
                <option value="-1">Other</option>
            </select>
            <label for="floatingCountry">Country: <span class="required">*</span></label>
            <div v-for="error of v$.dataSetId.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
        </div>

        <div class="mb-3">
            <template v-if="store.dataSetId > 0">
                <div class="input-group">
                    <span class="input-group-text">
                        {{ selectedDataSet.prefix }}
                    </span>
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingTailNumber" v-model="store.aircraftTailNumber" :class="{ 'is-invalid': v$.aircraftTailNumber.$errors.length > 0 }" @blur="lookupAircraft" />
                        <label for="floatingTailNumber">Registration (Tail Number): <span class="required">*</span></label>
                        <div v-for="error of v$.aircraftTailNumber.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="form-floating">
                    <input type="text" class="form-control" id="floatingTailNumber" v-model="store.aircraftTailNumber" :class="{ 'is-invalid': v$.aircraftTailNumber.$errors.length > 0 }" />
                    <label for="floatingTailNumber">Registration (Tail Number): <span class="required">*</span></label>
                    <div v-for="error of v$.aircraftTailNumber.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                </div>
            </template>
        </div>

        <div class="mb-3 form-floating">
            <input type="text" class="form-control" id="floatingYear" placeholder="" v-model="store.aircraftYear" />
            <label for="floatingYear">Year:</label>
        </div>

        <div class="mb-3 form-floating">
            <input type="text" class="form-control" id="floatingMake" placeholder="" v-model="store.aircraftMake" />
            <label for="floatingMake">Make:</label>
        </div>

        <div class="mb-3 form-floating">
            <input type="text" class="form-control" id="floatingModel" placeholder="" v-model="store.aircraftModel" />
            <label for="floatingModel">Model:</label>
        </div>

        <div class="mb-3 form-floating">
            <select v-model="store.aircraftEngines" class="form-select" id="floatingEngines" :class="{ 'is-invalid': v$.aircraftEngines.$errors.length > 0 }">
                <option value="1">Single-engine</option>
                <option value="2">Multi-engine</option>
            </select>
            <label for="floatingEngines">Engines: <span class="required">*</span></label>
            <div v-for="error of v$.aircraftEngines.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
        </div>

        <div class="text-center">
            <button type="button" class="btn btn-primary" @click="goToPage('DATES')">Next</button>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { useStore } from './store';
    import useVuelidate from '@vuelidate/core';
    import { required } from '@vuelidate/validators';

    const emit = defineEmits(['goToPage']);

    const store = useStore();

    const rules = computed(() => ({
        dataSetId: { required },
        aircraftTailNumber: { required },
        aircraftEngines: { required }
    }));

    const v$ = useVuelidate(rules, store);

    const selectedDataSet = computed(() => {
        return store.dataSets.find(ds => ds.id == store.dataSetId);
    });

    function lookupAircraft() {

        $.ajax({
            url: store.aircraftLookupUrl + '/' + store.aircraftTailNumber + '?dataSetId=' + store.dataSetId,
            method: "GET",
            success: function (response) {
                store.aircraftYear = response.year;
                store.aircraftMake = response.make;
                store.aircraftModel = response.model;

                var engines = parseInt(response.engines);
                if (engines == 1) {
                    store.aircraftEngines = 1;
                }
                else {
                    store.aircraftEngines = 2;
                }
            }
        });
    }

    async function goToPage(pageName) {

        var isValid = await v$.value.$validate();

        if (isValid)
            emit('goToPage', pageName);
    }

</script>